import globalQueue from "global-queue";

function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function");
}

function stgCreateCookie(a, b, c) {
  var d = "";
  if (c) {
    var e = new Date();
    e.setTime(e.getTime() + 24 * c * 60 * 60 * 1e3),
      (d = "; expires=" + e.toUTCString());
  }
  document.cookie = a + "=" + b + d + "; path=/";
}

const tagManagerQueueIdentifier = "dataLayer";
const piwikAnalyticsQueueIdentifier = "_paq";

const isStgDebug =
  (window.location.href.match("stg_debug") ||
    window.document.cookie.match("stg_debug")) &&
  !window.location.href.match("stg_disable_debug");

/* global analytics */
analytics.use(() => {
  const dataLayerPush = globalQueue(tagManagerQueueIdentifier);
  const paqPush = globalQueue(piwikAnalyticsQueueIdentifier);

  /**
   * Expose `PiwikPro` integration.
   */
  const PiwikPro = analytics
    .integration("piwik-pro")
    .global(tagManagerQueueIdentifier)
    .global(piwikAnalyticsQueueIdentifier)
    .option("url", null)
    .option("siteId", "")
    .option("customVariableLimit", 5)
    .mapping("goals")
    .tag(opt => {
      let dl = "";

      if ("dataLayer" != tagManagerQueueIdentifier) {
        dl += "?dataLayer=" + tagManagerQueueIdentifier;
      }

      if (isStgDebug) {
        dl += "?stg_debug";
      }

      return {
        type: "script",
        attrs: { src: `//${opt.url}/containers/${opt.siteId}.js${dl}` }
      };
    });

  /**
   * Initialize.
   *
   * http://piwik.org/docs/javascript-tracking/#toc-asynchronous-tracking
   *
   * @api public
   */

  PiwikPro.prototype.initialize = function() {
    stgCreateCookie("stg_debug", isStgDebug ? 1 : "", isStgDebug ? 14 : -1);

    window._paq = window._paq || [];

    window[tagManagerQueueIdentifier] = window[tagManagerQueueIdentifier] || [];

    if (isStgDebug) {
      dataLayerPush({
        start: new Date().getTime(),
        event: "stg.start"
      });
    }

    !(function(a, n, i, t) {
      a[n] = a[n] || {};
      for (var c = 0; c < i.length; c++)
        !(function(i) {
          (a[n][i] = a[n][i] || {}),
            (a[n][i].api =
              a[n][i].api ||
              function() {
                var a = [].slice.call(arguments, 0),
                  t = a;
                "string" == typeof a[0] &&
                  (t = {
                    event: n + "." + i + ":" + a[0],
                    parameters: [].slice.call(arguments, 1)
                  }),
                  dataLayerPush(t);
              });
        })(i[c]);
    })(window, "ppms", ["tm", "cp", "cm"]);

    this.load(this.ready);
  };

  /**
   * Check if PiwikPro is loaded.
   *
   * @api private
   */

  PiwikPro.prototype.loaded = function() {
    return !!(
      window[dataLayer] && window[dataLayer].push !== Array.prototype.push
    );
  };

  /**
   * Page
   *
   * @api public
   * @param {Page} page
   */

  PiwikPro.prototype.page = function(page) {
    paqPush("trackPageView", page.fullName());
  };

  /**
   * Identify
   *
   * @api public
   * @param {Identify} identify
   */
  PiwikPro.prototype.identify = function(identify) {
    if (!identify.userId()) {
      return;
    }
    // Ref: http://developer.piwik.org/guides/tracking-javascript-guide#user-id
    paqPush("setUserId", identify.userId().toString());
  };

  /**
   * Track.
   *
   * @api public
   * @param {Track} track
   */

  PiwikPro.prototype.track = function(track) {
    let goals = this.goals(track.event());
    const revenue = track.revenue();
    const category = track.category() || "All";
    const action = track.event();
    const name = track.name();
    const value = track.value() || track.revenue();

    const options = track.options("piwik-pro");
    let customVariables = options.customVars || options.cvar;
    let customDimensions = options.customDimensions;
    if (!isObject(customVariables)) {
      customVariables = {};
    }
    if (!isObject(customDimensions)) {
      customDimensions = {};
    }

    if (options.goalId) {
      goals = goals.concat(options.goalId);
    }

    for (let i = 1; i <= this.options.customVariableLimit; i += 1) {
      if (customVariables[i]) {
        paqPush(
          "setCustomVariable",
          i.toString(),
          customVariables[i][0],
          customVariables[i][1],
          "page"
        );
      }
    }
    Object.keys(customDimensions)
      .filter(key => !!customDimensions[key])
      .forEach(key =>
        paqPush(
          "setCustomDimension",
          key,
          encodeURIComponent(customDimensions[key].value)
        )
      );

    if (goals.length) {
      goals.forEach(goal => {
        paqPush("trackGoal", goal, revenue);
      });
    }

    paqPush("trackEvent", category, action, name, value);
    // when we set custom dimensions they are set for all events until a new
    // page view happen so if we want to have them only for one event we need to
    // delete them after
    Object.keys(customDimensions)
      .filter(
        key => !!customDimensions[key] && !customDimensions[key].keepAfterEvent
      )
      .forEach(key => paqPush("deleteCustomDimension", key));
  };

  return PiwikPro;
});
